<div class="row hero-image-card">
    <div class="col-md-12">
        <div class="card card-custom card-stretch">
            <div class="code-box_title">
                <h4>{{ 'SETTING_PAGE.INFORMATE_SETTINGS.DEFAULTS_TAB.UNITS' | transloco }}</h4>
            </div>
            <div class="card-body" *ngIf="form">
                <div [formGroup]="form" class="row" *ngIf="defaultUnitOptions != undefined">
                    <div class="col-2 mb-5">
                        <mat-label class="font-style">{{ 'SETTING_PAGE.INFORMATE_SETTINGS.DEFAULTS_TAB.METRIC' | transloco }} :</mat-label>
                    </div>
                    <div class="col-10 toggle-wrap mb-5">
                        <mat-slide-toggle name="metric" [checked]="defaultUnitMetric" (change)="changeDefault($event)"></mat-slide-toggle>
                    </div>

                    <div class="col-2 mb-5">
                        <mat-label class="font-style">{{ 'SETTING_PAGE.INFORMATE_SETTINGS.DEFAULTS_TAB.IMPERIAL' | transloco }} :</mat-label>
                    </div>
                    <div class="col-10 toggle-wrap mb-5">
                        <mat-slide-toggle name="imperial" [checked]="defaultUnitImperial" (change)="changeDefault($event)"></mat-slide-toggle>
                    </div>

                    <div class="col-md-2 mb-5">
                        <mat-label class="font-style">{{ 'SETTING_PAGE.INFORMATE_SETTINGS.DEFAULTS_TAB.CUSTOM' | transloco }} :</mat-label>
                    </div>
                    <div class="col-md-10 mb-5 grid-container-units">
                        <div *ngFor="let item of defaultUnitOptions; trackBy: trackById">
                            <div class="row">
                                <div class="col-xl-4 col-lg-4 pd-8-15">
                                    <mat-label class="font-style">{{ item.setting.name }}</mat-label>
                                </div>
                                <div class="col-xl-8 col-lg-8 method-select-btn" *ngIf="extractOptions(item.setting.settingValues)?.length">
                                    <!-- <p-selectButton [options]="getOtionbyKeys(item?.setting?.key)"
                                        [formControlName]="item.setting.key" (onOptionClick)="changeOption($event)"
                                        optionLabel="label" optionValue="value"></p-selectButton> -->
                                    <div class="btn-group custom-toggle-wrap" role="group">
                                        <label
                                            *ngFor="let opt of getOtionbyKeys(item?.setting?.key)"
                                            class="btn custom-toggle"
                                            [class.active]="form.get(item.setting.key)?.value === opt.value"
                                        >
                                            <input
                                                type="radio"
                                                class="btn-check"
                                                [formControlName]="item.setting.key"
                                                [value]="opt.value"
                                                (change)="onRadioChange(opt.value)"
                                                autocomplete="off"
                                            />

                                            {{ opt.label }}
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
